import { render, staticRenderFns } from "./personalAuthFlow.vue?vue&type=template&id=5df260a0&scoped=true"
import script from "./personalAuthFlow.vue?vue&type=script&lang=js"
export * from "./personalAuthFlow.vue?vue&type=script&lang=js"
import style0 from "./personalAuthFlow.vue?vue&type=style&index=0&id=5df260a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df260a0",
  null
  
)

export default component.exports